

class GlobalClickManager
{

    constructor() {

        this.haveFirstClick = false;
        /** @type {(() => void)[]} */
        this.firstClickListeners = [];
        this.init();
    }

    init(){
        $(document).on("touchend mouseup" , (e) =>
        {
            this.registerClick();
        })
    }

    registerClick()
    {
        if(!this.haveFirstClick){
            this.haveFirstClick = true;
            for(let i = 0; i < this.firstClickListeners.length; i++){
                this.firstClickListeners[i]();
            }
            this.firstClickListeners.length = 0;
        }
    }

    /**
     *
     * @param callback {() => void}
     */
    requireFirstClick(callback){
        if(this.haveFirstClick){
            callback();
        } else {
            this.firstClickListeners.push(callback);
        }
    }
}

let _globalClickManager = null;

/**
 *
 * @returns {GlobalClickManager}
 */
const getGlobalClickManager = () => {
    if(_globalClickManager !== null){
        return _globalClickManager;
    }
    _globalClickManager = new GlobalClickManager();
    return _globalClickManager;
}


$(document).ready(() =>
{
    getGlobalClickManager();
});